import { EditSendToTargetsModel } from "models/EditSendToTargetsModel";
import { createContext } from "react";

interface BoardSendToContextProps {
  results: EditSendToTargetsModel | undefined;
  isLoading: boolean;
  isPanelOpen: boolean;
  openPanel: () => void;
  closePanel: () => void;
  addOutgoing: (targetId: number) => Promise<void>;
  addIncoming: (sourceId: number) => Promise<void>;
  remove: (id: number) => Promise<void>;
  deletingId: number | null;
}

export const BoardSendToContext = createContext({} as BoardSendToContextProps);
